<template>
  <div
      class="notification"
      :class="[type]"
      @mouseover="pauseTimer"
      @mouseleave="resumeTimer"
  >
    <p><strong>{{ title }}</strong></p>
    <p>{{ message }}</p>
    <button class="close-btn" @click="closeNotification">&times;</button>
  </div>
</template>

<script>
export default {
  name: "Notification",
  props: {
    id: { type: Number, required: true },
    type: { type: String, default: "success" }, // success | error
    title: { type: String, required: true },
    message: { type: String, required: true },
    duration: { type: Number, default: 4000 }, // duración en milisegundos
  },
  data() {
    return {
      timer: null,
    };
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    startTimer() {
      this.timer = setTimeout(() => {
        this.closeNotification();
      }, this.duration);
    },
    pauseTimer() {
      clearTimeout(this.timer);
    },
    resumeTimer() {
      this.startTimer();
    },
    closeNotification() {
      this.$emit("remove", this.id);
    },
  },
};
</script>

<style scoped>
.notification {
  position: relative;
  padding: 15px 20px;
  margin-bottom: 10px;
  border-radius: 4px;
  font-family: Arial, sans-serif;
  color: #fff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  animation: slideIn 0.3s ease-out;
}
.notification.success {
  background-color: #4caf50;
}
.notification.error {
  background-color: #f44336;
}
.notification .close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
}
.notification .close-btn:hover {
  color: #000;
}
@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>
